<ca-dialog-header [titleElement]="titleElement"></ca-dialog-header>
<div class="flex flex-col gap-2">
    @for (description of data.descriptions; track description) {
        <mat-dialog-content class="py-0">
            <span class="whitespace-pre-line ca-text-lg tracking-normal">{{ description }}</span>
        </mat-dialog-content>
    }
</div>
<mat-dialog-actions class="dialog-actions py-4 px-6">
    <button
        mat-stroked-button
        class="ca-button ca-button-m"
        (click)="onCancel()"
        data-testid="confirm-dialog-cancel-btn"
        id="pop-up-cancel"
    >
        {{ data.cancelButton }}
    </button>
</mat-dialog-actions>

<ng-template #titleElement>
    <div class="flex flex-column gap-4">
        <mat-icon class="ca-message-icon" [ngClass]="data.iconType">{{ data.icon }}</mat-icon>
        <h1 class="font-semibold mb-4">
            <span class="me-3">{{ data.title }}</span>
        </h1>
    </div>
</ng-template>
